import { AlertModal } from '@/components/ui/AlertModal'
import type { BlockDialogKind } from '@/pages/SealedVinylPage/hooks/useProceedToPayment'
import { NOT_ENOUGH_STOCK_DIALOG, SOLD_OUT_DIALOG } from '@/pages/SealedVinylPage/lib/constants'

interface BlockStockAlertModalProps {
  /** 차단 사유 — 재고 소진(soldOut) / 재고 부족(notEnoughStock) */
  kind: BlockDialogKind
  onClose: () => void
}

/**
 * 재고 차단 안내 모달 — 신청/결제/수량변경 직전 가용성 재검증 실패 시 공용 사용.
 * soldOut/notEnoughStock 두 사유의 안내 카피만 다르고 동작은 동일(확인 1버튼).
 */
export function BlockStockAlertModal({ kind, onClose }: BlockStockAlertModalProps) {
  const dialog = kind === 'soldOut' ? SOLD_OUT_DIALOG : NOT_ENOUGH_STOCK_DIALOG
  return (
    <AlertModal
      isOpen
      onClose={onClose}
      title={dialog.title}
      description={dialog.description}
      primaryAction={{ label: '확인', onClick: onClose }}
    />
  )
}
